import { UserInterface } from '@/domains/User';
import { userAdapter } from '@/services/adapters';
import { getResource } from '@/api/auth';

class UserService implements UserInterface {
  async getUser() {
    const user = await getResource();

    return userAdapter.toInternal(user);
  }
}

export const userService = new UserService();
